import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getRegionsForUpload = async (network) => {
  try {
    const resp = await apiClient.get(`/kmz/upload/regions/${network}`);
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
